export default import.meta.ROLLUP_FILE_URL_U6muqRGa8aHtq8t0c9wAzg;